import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store/store";

export const getDeviceListFilters = (state: RootState) =>
  state.page.devicePageFilters;

export const getIssuesListFilters = (state: RootState) =>
  state.page.issuesPageFilters;

export const getAuditTrailFilters = (state: RootState) =>
  state.page.auditTrailPageFilters;

export const getDashboardOverview = (state: RootState) =>
  state.page.dashboardOverview;

export const getDashboardActions = (state: RootState) =>
  state.page.dashboardActions;

export const getAlertsListFilters = (state: RootState) =>
  state.page.alertsPageFilters;

export const getSitesListFilters = (state: RootState) =>
  state.page.sitesPageFilters;

export const getUsersListFilters = (state: RootState) =>
  state.page.usersPageFilters;
